<template>
  <div class="wrapper">
    <img src="@/assets/brief/logo2.png" class="logo">
    <ul class="content">
      <li class="name">茂名市慢性病防治中心</li>
      <li class="grade">
        <span>二级专科</span>
        <!-- <span>综合医院</span> -->
      </li>
      <li class="phone_area">
        <span>
          <img src="@/assets/brief/phone2.png">
          <span>0668-2102097</span>
        </span>
        <span>
          <img src="@/assets/brief/area.png">
          <span>广东省茂名市计星路一巷10号</span>
        </span>
        <a href="tel:0668-2102097" class="callphone"><img src="@/assets/brief/phone1.png"></a>
      </li>
      <li class="details">
        <p>医院简介</p>
        <span>
          茂名市慢性病防治医院，是市直属卫生单位，也是国家规定的茂名地区结核病、皮肤性病、精神病等慢性病的预防、
          治疗、监测、控制专业防治管理机构。医院属下有茂名皮肤病防治中心、茂名市性病防治中心、茂名市精神病防治中心、
          茂名市结核病防治所。 茂名市慢性病防治医院门诊专科设有皮肤性病科、妇科、精神科、结核病科、呼吸内科、老年病科、
          社区保健科，同时设置140张病床的皮肤科、精神病科、呼吸内科等三个病区。 茂名市慢性病防治医院现有专业技术人员100余人，
          其中中级以上职称20人；此外，拥有X光、B超、心电图、脑电地形图、尿十项分析、生化分析、细菌鉴定及药敏测试系统、
          荧光落射显微系统、PCR扩增仪、激光、微波电离子治疗仪等一大批先进医疗设备。 茂名市慢性病防治医院一贯坚持“预防为主，
          防治结合”的工作方针，把“救死扶伤，防病治病”作为天职和已任，立足市区，面向基层，服务群众，在防治工作中充分显示出“专科、
          专病、专医、专药”的医疗特色。 茂名市慢性病防治医院将一如既往地为本地区防性疾病控制竭尽全力，为社会各界提供更加优质、
          安全、快速、价廉的医疗卫生服务。 
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  .logo{
    width: 375px;
    height: 313px;
  }
  .content{
    padding: 25px;
    display: flex;
    flex-flow: column nowrap;
    letter-spacing: 1px;
    .name{
      font-size: 17px;
      font-weight: bold;
    }
    .grade{
      margin: 14px 0px 22px;
      font-size: 14px;
      >span{
        color: #2A9DCE;
        margin-right: 4px;
        padding: 3px 7px;
        border: 1px solid #2A9DCE;
        border-radius: 3px;
      }
    }
    .phone_area{
      position: relative;
      display: flex;
      flex-flow: column nowrap;
      font-size: 14px;
      color: #BEBEBE;
      border-bottom: 1px solid #C2C2C2;
      padding-bottom: 10px;
      >span{
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        margin-bottom: 4px;
        >img{
          width: 17px;
          height: 20px;
        }
        >span{
          margin-left: 6px;
        }
      }
      .callphone{
        position: absolute;
        top: -7px;
        right: 0px;
        width: 32px;
        height: 32px;
        >img{
          width: 32px;
          height: 32px;
        }
      }
    }
    .details{
      >p{
        font-size: 17px;
        margin: 24px 0px 14px;
        font-weight: 600;
      }
      >span{
        line-height: 25px;
        font-size: 14px;
        color: #707070;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/website/HospitalProfile.vue